import React from 'react';
import { withAuthDomain } from '../../components/Session';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import {Grid, Paper, Typography } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
//import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Accordion  from '@material-ui/core/Accordion';
import Clock,{twoDigits,toSimpleDateTimestamp,convertMonthToName} from '../../components/Fragment/Clock.js'
//import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {PlanLevelBadge,numberToRupiah,PricingProDetail,PricingNonProDetail} from '../CompanyBillings'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import LinearProgress from '@material-ui/core/LinearProgress';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/StarBorder';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Divider from '@material-ui/core/Divider';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  rootTab: {
    //flexGrow: 1,
    //width: `calc(100% - 80px)`,
    //backgroundColor: theme.palette.background.paper,
    
  },
  root: {
    overscrollBehavior: "contain",
    maxWidth:"100vw",
    minHeight:"89vh",
    overflow:"auto",
    margin:"0px",
    padding:"0px",
    paddingBottom:"70px",
    position:"relative",
    userSelect:"none", 
  },
  paper:{
    margin:"10px",
    padding:"20px",
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
}));

function TabPanel(props) {
  const { children, value, index, onShow, ...other } = props;
  React.useEffect(()=>{
    if(!!onShow && value === index)onShow()
  },[value,index,onShow])
  return (
    <>
      {value === index && children}
    </>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const SecureBillingsPage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
  }=props
  const classes = useStyles();
  
  //const [monthlyBills,setMonthlyBills]=React.useState([])
  const [monthlyBillsVerifikasi,setMonthlyBillsVerifikasi]=React.useState([])
  const [monthlyBillsMenunggu,setMonthlyBillsMenunggu]=React.useState([])
  const [monthlyBillsLUNAS,setMonthlyBillsLUNAS]=React.useState([])
  const [monthlyBillsPROGRESS,setMonthlyBillsPROGRESS]=React.useState([])
  const [monthlyBillsSUSPEND,setMonthlyBillsSUSPEND]=React.useState([])
  const [monthlyBillsBANNED,setMonthlyBillsBANNED]=React.useState([])
  const [monthlyBillsERROR,setMonthlyBillsERROR]=React.useState([])
  
  const [getVerifikasi,setGetVerifikasi]=React.useState(false)
  const [getMenunggu,setGetMenunggu]=React.useState(false)
  const [getLUNAS,setGetLUNAS]=React.useState(false)
  const [getPROGRESS,setGetPROGRESS]=React.useState(false)
  const [getSUSPEND,setGetSUSPEND]=React.useState(false)
  const [getBANNED,setGetBANNED]=React.useState(false)
  const [getERROR,setGetERROR]=React.useState(false)

  React.useEffect(()=>{
    if(!!activeCompany&&getVerifikasi){
      //console.log("setMonthlyBillsVerifikasi")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","Proses Verifikasi")
      .orderBy("paymentDate")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsVerifikasi(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getVerifikasi])

  React.useEffect(()=>{
    if(!!activeCompany&&getMenunggu){
      //console.log("setMonthlyBillsMenunggu")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","Menunggu Pembayaran")
      .orderBy("id")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsMenunggu(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getMenunggu])

  React.useEffect(()=>{
    if(!!activeCompany&&getLUNAS){
      //console.log("setMonthlyBillsLUNAS")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","LUNAS")
      .orderBy("paymentApprovedDate")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsLUNAS(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getLUNAS])

  React.useEffect(()=>{
    if(!!activeCompany&&getPROGRESS){
      //console.log("setMonthlyBillsPROGRESS")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","")
      .orderBy("id")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsPROGRESS(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getPROGRESS])
  
  React.useEffect(()=>{
    if(!!activeCompany&&getSUSPEND){
      //console.log("setMonthlyBillsSUSPEND")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","SUSPEND")
      .orderBy("id")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsSUSPEND(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getSUSPEND])

  React.useEffect(()=>{
    if(!!activeCompany&&getBANNED){
      //console.log("setMonthlyBillsBANNED")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","BANNED")
      .orderBy("id")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsBANNED(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getBANNED])

  React.useEffect(()=>{
    if(!!activeCompany&&getERROR){
      //console.log("setMonthlyBillsERROR")
      return firebase.fs.collectionGroup('monthlyBills').where('planLevel', 'in', ['BASIC','PRO'])
      .where("statusBills","==","ERROR")
      .orderBy("id")
      .orderBy("amountBills","desc")
      .limit(10)
      .onSnapshot( (querySnapshot)=> {
        var list=[]
        querySnapshot.forEach((doc)=>{
          list.push(doc.data())
        })
        setMonthlyBillsERROR(list)
        //console.log(list.length,list)
      });
    }
  },[firebase,activeCompany,getERROR])
 

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [initializing,setInitializing]=React.useState(false)
  
  function handleInitializateAllMonthlyBills(){
    var id=window.prompt("Masukkan 6 digit tahun dan bulan dg format YYYYMM")
    if(id.length!==6)return
    var initializeAllMonthlyBills = firebase.fn.httpsCallable('initializeAllMonthlyBills')
    setInitializing(true)
    initializeAllMonthlyBills({
      id:id,
    }).then((res)=>{
      setInitializing(false)
      //console.log("result",res.data)
      console.log("Done\nSuccess = "+
      res.data.initializationSuccessCount+
      "\nExists = "+res.data.initializationExistsCount+
      "\nCompany bills = "+res.data.companyBillingsCreated+
      "\nBranch bills = "+res.data.branchBillingsCreated)

      window.alert("Done\nSuccess = "+
      res.data.initializationSuccessCount+
      "\nExists = "+res.data.initializationExistsCount+
      "\nCompany bills = "+res.data.companyBillingsCreated+
      "\nBranch bills = "+res.data.branchBillingsCreated)
    }).catch(e=>{
      setInitializing(false)
      window.alert("Gagal : "+e)
    })
  }

  function handleSendEmailFunction(){
    var to=window.prompt("Masukkan alamat email tujuan")
    if(!to)return
    var html=window.prompt("Masukkan pesan")
    if(!html)return
    var sendEmail = firebase.fn.httpsCallable('sendEmail')
    setInitializing(true)
    sendEmail({
      to:to,
      html:html,
    }).then((res)=>{
      setInitializing(false)
      console.log("Done")
      window.alert("Done")
    }).catch(e=>{
      setInitializing(false)
      window.alert("Gagal : "+e)
    })
  }

  return (
    <div className={classes.root}>
      {sessionDomain>=1&&
      <div className={classes.rootTab} style={{width:width==="xs"||false?"100%":"calc(100% - 80px)"}} >
        <AppBar position="static" color="default" >
          <Button onClick={handleInitializateAllMonthlyBills} color="secondary" disabled={initializing}>Init All Monthly Bills</Button>
          <Button onClick={handleSendEmailFunction} color="secondary" disabled={initializing}>Send Email</Button>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Verifikasi" {...a11yProps(0)} />
          <Tab label="Menunggu Pembayaran" {...a11yProps(1)} />
          <Tab label="LUNAS" {...a11yProps(2)} />
          <Tab label="PROGRESS" {...a11yProps(3)} />
          <Tab label="SUSPEND" {...a11yProps(4)} />
          <Tab label="BANNED" {...a11yProps(5)} />
          <Tab label="ERROR" {...a11yProps(6)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} onShow={()=>{setGetVerifikasi(true)}}>
        <BillingList {...props} title="Butuh Verifikasi"
          list={monthlyBillsVerifikasi}/>
      </TabPanel>
      <TabPanel value={value} index={1} onShow={()=>{setGetMenunggu(true)}}>
        <BillingList {...props} title="Menunggu Pembayaran"
          list={monthlyBillsMenunggu}/>
      </TabPanel>
      <TabPanel value={value} index={2} onShow={()=>{setGetLUNAS(true)}}>
        <BillingList {...props} title="LUNAS"
          list={monthlyBillsLUNAS}/>
      </TabPanel>
      <TabPanel value={value} index={3} onShow={()=>{setGetPROGRESS(true)}}>
        <BillingList {...props} title="Estimasi Tagihan (BASIC/PRO)"
          list={monthlyBillsPROGRESS}/>
      </TabPanel>
      <TabPanel value={value} index={4} onShow={()=>{setGetSUSPEND(true)}}>
        <BillingList {...props} title="SUSPEND"
          list={monthlyBillsSUSPEND}/>
      </TabPanel>
      <TabPanel value={value} index={5} onShow={()=>{setGetBANNED(true)}}>
        <BillingList {...props} title="BANNED"
          list={monthlyBillsBANNED}/>
        </TabPanel>
      <TabPanel value={value} index={6} onShow={()=>{setGetERROR(true)}}>
        <BillingList {...props} title="ERROR"
          list={monthlyBillsERROR}/>
      </TabPanel>
      
      </div>
      }
    </div>
  )
}

function BillingList(props){
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
    title,
    list=[],
  }=props
  const classes = useStyles();


  const [dataList,setDataList]=React.useState(list)

  React.useEffect(()=>{
    setDataList(list)
  },[list])
  
  return (
    <div>
    <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
      <Typography variant="h5">
        {title}
      </Typography>
      <br/>
      {dataList.map((data,idx)=>
        <BillingDetails key={data.companyId+data.branchId+data.id||idx} data={data} idx={idx} {...props}/>
      )}

    </Paper>
    </div>
  )
}

function BillingDetails(props){
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
    data,
  }=props
  const classes = useStyles();
  const [expandedUsages,setExpandedUsages]=React.useState(false)
  const [updating,setUpdating]=React.useState(false)


  function handleBillApproved(){
    var approveBillingPayment = firebase.fn.httpsCallable('approveBillingPayment')
    setUpdating(true)
    approveBillingPayment({
      id:data.id,
      companyId:data.companyId,
      branchId:data.branchId,
      email:data.billedEmail,
    }).then(()=>{
      setUpdating(false)
      //var mail = document.createElement("a");
      //mail.href = "mailto:"+data.email+"?subject=Terimakasih"
      //mail.click();
    }).catch(e=>{
      setUpdating(false)
      window.alert("Gagal : "+e)
    })
  }

  function handleBillRejected(){
    var rejectedReason=window.prompt("Sebutkan alasan pembayaran ditolak!")
    if(!rejectedReason)return
    var rejectBillingPayment = firebase.fn.httpsCallable('rejectBillingPayment')
    setUpdating(true)
    rejectBillingPayment({
      id:data.id,
      companyId:data.companyId,
      branchId:data.branchId,
      rejectedReason:rejectedReason,
      email:data.billedEmail,
    }).then(()=>{
      setUpdating(false)
      //var mail = document.createElement("a");
      //mail.href = "mailto:"+data.email+"?subject=Mohon%20Maaf"
      //mail.click();
    }).catch(e=>{
      setUpdating(false)
      window.alert("Gagal : "+e)
    })
  }

  function handleSendEmail(){
    var mail = document.createElement("a");
    mail.href = "mailto:"+data.email+"?subject=Selamat%20Pagi"
    mail.click();
  }

  function handleBlockCompany(){
    
  }
  function handleBlockBranch(){
    
  }

  function handleMakeABill(){
    var id=window.prompt("Masukkan tahun dan bulan")
    if(id!==data.id)return
    var calculateAndMakeMonthlyBill = firebase.fn.httpsCallable('calculateAndMakeMonthlyBill')
    setUpdating(true)
    calculateAndMakeMonthlyBill({
      id:data.id,
      companyId:data.companyId,
      branchId:data.branchId,
    }).then(()=>{
      setUpdating(false)
    }).catch(e=>{
      setUpdating(false)
      window.alert("Gagal : "+e)
    })
  }


  return (
    <>
    <Accordion expanded={expandedUsages} onChange={()=>{setExpandedUsages(!expandedUsages)}}
      style={{
        backgroundColor:data.statusBills==="LUNAS"?"rgb(225,255,225)":data.statusBills==="Menunggu Pembayaran"?"rgb(252,252,208)":(data.statusBills==="Proses Verifikasi"||data.statusBills==="")?"#e0e0e0":"#fb85a8",
        borderColor:data.statusBills==="LUNAS"?"rgb(0,244,0)":data.statusBills==="Menunggu Pembayaran"?"rgb(247,241,13)":(data.statusBills==="Proses Verifikasi"||data.statusBills==="")?"#888888":"rgb(231,45,12)",
        borderRadius: expandedUsages?"10px":"0px",
        borderStyle:"solid",
      }}
      >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <div style={{width:"100%"}}>
          <Typography variant="h6" style={{fontWeight:"bold"}}>
            {data.branchName||data.branchId} {width!=="xs"?<span style={{fontSize:"smaller"}}> - {data.companyName||data.companyId}</span>:null}
          </Typography>
          <Typography variant="h6" style={{fontWeight:"bold"}}>
            {convertMonthToName(parseInt(data.monthBills))} {data.yearBills}
          </Typography>
          <PlanLevelBadge plan={data.planLevel} style={{clear:"left",float:"left"}}/>
          {!expandedUsages&&<Typography variant="h5" style={{clear:"right",float:"right",fontWeight:"bold",}}>{numberToRupiah(data.amountBills)}</Typography>}
          {(!expandedUsages&&(data.statusBills==="Menunggu Pembayaran"||data.statusBills==="Proses Verifikasi")&&!!data.rejectedReason)&&<span style={{float:"left",clear:"both",color:"red"}}><b>{data.rejectedReason}</b></span>}
          {(!expandedUsages&&(data.statusBills==="Menunggu Pembayaran"||data.statusBills==="Proses Verifikas")&&!!data.dueDateBills)&&<span style={{float:"left",clear:"both"}}><i>Jatuh tempo : {toSimpleDateTimestamp(parseInt(data.dueDateBills))}</i></span>}
        </div>
        
      </AccordionSummary>
      <AccordionDetails>
      <div style={{textAlign:"center",width:"100%"}}>
        <Divider style={{marginBottom:"20px"}}/>
        <Typography variant="h5" style={{textAlign:"center",fontWeight:"bold"}}>
          {data.statusBills||"Estimasi Tagihan"}<br/>
          {!data.amountBills?"FREE":numberToRupiah(data.amountBills)}
          {(expandedUsages&&(data.statusBills==="Menunggu Pembayaran"||data.statusBills==="Proses Verifikasi")&&!!data.dueDateBills)&&<span style={{fontSize:"16px"}}><br/><i>Jatuh tempo : {toSimpleDateTimestamp(parseInt(data.dueDateBills))}</i></span>}
          {(expandedUsages&&(data.statusBills==="Menunggu Pembayaran"||data.statusBills==="Proses Verifikasi")&&!!data.rejectedReason)&&<span style={{fontSize:"16px",color:"red"}}><br/><b>{data.rejectedReason}</b></span>}
        </Typography>
        
        <Divider style={{margin:"20px auto"}}/>
        {(data.statusBills==="LUNAS"||data.statusBills==="Proses Verifikasi")&&
          <img width={width==="xs"?"100%":"320px"} height="auto" style={{objectFit: "contain",border:"1px solid black"}} src={data.paymentLink} alt={data.paymentLink}/>
        }
        {data.statusBills==="Proses Verifikasi"&&
          <Typography variant="subtitle1" >
            Periksa transferan tersebut sudah masuk atau belum. Bila sudah, maka klik TERIMA. Bila belum atau foto kurang jelas, klik TOLAK beserta alasannya.
          </Typography>
        }
        
        
        {updating&&<LinearProgress/>}
        <div style={{marginTop:"20px"}}>
          <Grid container direction="row" justify="center" alignItems="center" spacing={4}>
            {(data.statusBills==="Proses Verifikasi"||data.statusBills==="LUNAS")&&
              <Grid item>
                <Button variant="contained" disabled={updating} color="secondary" onClick={handleBillRejected}>
                  {data.statusBills==="LUNAS"?"BATALKAN PEMBAYARAN":"TOLAK"}
                </Button>
              </Grid>
            }
            {data.statusBills==="Menunggu Pembayaran"&&
              <Grid item>
                <Button variant="contained" disabled={updating} color="secondary" onClick={handleBlockCompany}>
                  BLOKIR PERUSAHAAN
                </Button>
              </Grid>
            }
            {data.statusBills==="Menunggu Pembayaran"&&
              <Grid item>
                <Button variant="contained" disabled={updating} color="secondary" onClick={handleBlockBranch}>
                  BLOKIR CABANG
                </Button>
              </Grid>
            }
            
            {data.statusBills==="Proses Verifikasi"&&
              <Grid item>
                <Button variant="contained" disabled={updating} color="primary" onClick={handleBillApproved}>
                  TERIMA
                </Button>
              </Grid>
            }
            {(data.statusBills==="LUNAS"||data.statusBills==="Menunggu Pembayaran"||data.statusBills==="")&&
              <Grid item>
                <Button variant="contained" disabled={updating} color="primary" onClick={handleSendEmail}>
                  KIRIM EMAIL
                </Button>
              </Grid>
            }
            {data.statusBills===""&&
              <Grid item>
                <Button variant="contained" disabled={updating} color="primary" onClick={handleMakeABill}>
                  BUAT TAGIHAN
                </Button>
              </Grid>
            }
            
          </Grid>
        </div>
        <Divider style={{margin:"20px auto"}}/>
        <PricingNonProDetail usage={data} width={width}/>
        <PricingProDetail usage={data} width={width}/>
      
      </div>
      
      </AccordionDetails>
    </Accordion>
    </>
  )
}

const condition = authUser => !!authUser;
export default withAuthDomain(condition,false,"online-asset-manager","online-asset-manager.secure.billings")(withWidth()(SecureBillingsPage));